import { Pipe, PipeTransform } from '@angular/core';
import { AppService } from '../shared/services/app.service';
//import moment from 'proxies/dayjs';
//import * as moment from 'moment-timezone';
import { UtilService } from '../services/util.service';

@Pipe({
    name: 'mapvalue',
    standalone: false
})
export class MapValuePipe implements PipeTransform {
    constructor(private appService: AppService, private utilService: UtilService) { }
    transform(data: any, json: any) {
        //let default_format = format ? format : this.appService._default_user_data['data_format'];
        // return this.utilService.toTimeZoneDateFormat(date, 'date'); //this.utilService.toTimeZoneDate(date).format(`${default_format}`);
        let value = this.utilService.getValue(data, json);
        return this.utilService.transformToDigit(value,json);
    }

}
